const pageNameKey = "editServiceUserDrawerModal";

export const editServiceUserDrawerModalEn = {
  [pageNameKey]: {
    editServiceUserTitle: "Edit service user",
    serviceUserUsernameLabel: "Service username",
    serviceUserUsernameInputPlaceholder: "Enter service username",
    serviceUserNameLabel: "Name",
    serviceUserNameInputPlaceholder: "Enter name",
    serviceUserDescriptionLabel: "Description",
    serviceUserDescriptionInputPlaceholder: "Enter description",
    expirationDateLabel: "Expiration Date",
    noExpirationDateText: "No expiration date available",
    updateServiceUserButtonText: "Update service user",
    cancelButtonText: "Cancel",
    activeStatusText: "Active",
    inactiveStatusText: "Inactive",
    initialStatusText: "Initial",
    rolesWarningText: "Please assign at least one role to the service user.",
    inputsCheckWarningText: "Please fix the following fields",
    userUpdatedSuccessText: "Service user updated successfully",
    detailsAndStatusErrorText:
      "Failed to update service user details and status",
    detailsErrorText: "Failed to update service user details",
    statusErrorText: "Failed to update service user status",
  },
};

export const editServiceUserDrawerModalPtBr = {
  [pageNameKey]: {
    editServiceUserTitle: "Editar usuário do serviço",
    serviceUserUsernameLabel: "Nome de usuário do serviço",
    serviceUserUsernameInputPlaceholder: "Digite o nome de usuário do serviço",
    serviceUserNameLabel: "Nome",
    serviceUserNameInputPlaceholder: "Digite o nome",
    serviceUserDescriptionLabel: "Descrição",
    serviceUserDescriptionInputPlaceholder: "Digite a descrição",
    expirationDateLabel: "Data de validade",
    noExpirationDateText: "Nenhuma data de validade disponível",
    updateServiceUserButtonText: "Atualizar usuário do serviço",
    cancelButtonText: "Cancelar",
    activeStatusText: "Ativo",
    inactiveStatusText: "Inativo",
    initialStatusText: "Inicial",
    rolesWarningText: "Atribua pelo menos uma função ao usuário de serviço.",
    inputsCheckWarningText: "Corrija os seguintes campos",
    userUpdatedSuccessText: "Usuário do serviço atualizado com sucesso",
    detailsAndStatusErrorText:
      "Falha ao atualizar os detalhes e o status do usuário de serviço",
    detailsErrorText: "Falha ao atualizar os detalhes do usuário de serviço",
    statusErrorText: "Falha ao atualizar o status do usuário de serviço",
  },
};

export const editServiceUserDrawerModalDe = {
  [pageNameKey]: {
    editServiceUserTitle: "Service-Benutzer bearbeiten",
    serviceUserUsernameLabel: "Service-Benutzername",
    serviceUserUsernameInputPlaceholder: "Service-Benutzernamen eingeben",
    serviceUserNameLabel: "Name",
    serviceUserNameInputPlaceholder: "Name eingeben",
    serviceUserDescriptionLabel: "Beschreibung",
    serviceUserDescriptionInputPlaceholder: "Beschreibung eingeben",
    expirationDateLabel: "Ablaufdatum",
    noExpirationDateText: "Kein Ablaufdatum verfügbar",
    updateServiceUserButtonText: "Service-Benutzer aktualisieren",
    cancelButtonText: "Abbrechen",
    activeStatusText: "Aktiv",
    inactiveStatusText: "Inaktiv",
    initialStatusText: "Initial",
    rolesWarningText:
      "Bitte weisen Sie dem Service-Benutzer mindestens eine Rolle zu.",
    userUpdatedSuccessText: "Service-Benutzer erfolgreich aktualisiert",
    inputsCheckWarningText: "Bitte beheben Sie die folgenden Felder",
    detailsAndStatusErrorText:
      "Fehler beim Aktualisieren der Service-Benutzer-Details und des Status",
    detailsErrorText: "Fehler beim Aktualisieren der Service-Benutzer-Details",
    statusErrorText: "Fehler beim Aktualisieren des Service-Benutzer-Status",
  },
};

export const editServiceUserDrawerModalZhHans = {
  [pageNameKey]: {
    editServiceUserTitle: "编辑服务用户",
    serviceUserUsernameLabel: "服务用户名",
    serviceUserUsernameInputPlaceholder: "输入服务用户名",
    serviceUserNameLabel: "名称",
    serviceUserNameInputPlaceholder: "输入名称",
    serviceUserDescriptionLabel: "描述",
    serviceUserDescriptionInputPlaceholder: "输入描述",
    expirationDateLabel: "到期日期",
    noExpirationDateText: "没有可用的到期日期",
    updateServiceUserButtonText: "更新服务用户",
    cancelButtonText: "取消",
    activeStatusText: "活跃",
    inactiveStatusText: "非活跃",
    initialStatusText: "初始",
    rolesWarningText: "请至少为服务用户分配一个角色。",
    userUpdatedSuccessText: "服务用户更新成功",
    inputsCheckWarningText: "请修正以下字段",
    detailsAndStatusErrorText: "更新服务用户详情和状态失败",
    detailsErrorText: "更新服务用户详情失败",
    statusErrorText: "更新服务用户状态失败",
  },
};

export const editServiceUserDrawerModalIt = {
  [pageNameKey]: {
    editServiceUserTitle: "Modifica utente di servizio",
    serviceUserUsernameLabel: "Nome utente",
    serviceUserUsernameInputPlaceholder: "Immettere il nome utente",
    serviceUserNameLabel: "Nome",
    serviceUserNameInputPlaceholder: "Inserisci il nome",
    serviceUserDescriptionLabel: "Descrizione",
    serviceUserDescriptionInputPlaceholder: "Inserisci descrizione",
    expirationDateLabel: "Data di scadenza",
    noExpirationDateText: "Nessuna data di scadenza disponibile",
    updateServiceUserButtonText: "Aggiorna l'utente",
    cancelButtonText: "Annulla",
    activeStatusText: "Attivo",
    inactiveStatusText: "Inattivo",
    initialStatusText: "Iniziale",
    rolesWarningText:
      "Si prega di assegnare almeno un ruolo all'utente di servizio.",
    inputsCheckWarningText: "Si prega di correggere i campi seguenti",
    userUpdatedSuccessText: "Utente di servizio aggiornato con successo",
    detailsAndStatusErrorText:
      "Impossibile aggiornare i dettagli dell'utente di servizio e lo stato",
    detailsErrorText:
      "Impossibile aggiornare i dettagli dell'utente di servizio",
    statusErrorText: "Impossibile aggiornare lo stato dell'utente di servizio",
  },
};

export const editServiceUserDrawerModalEs = {
  [pageNameKey]: {
    editServiceUserTitle: "Editar usuario de servicio",
    serviceUserUsernameLabel: "Nombre de usuario del servicio",
    serviceUserUsernameInputPlaceholder:
      "Introduce el nombre de usuario del servicio",
    serviceUserNameLabel: "Nombre",
    serviceUserNameInputPlaceholder: "Ingresa el nombre",
    serviceUserDescriptionLabel: "Descripción",
    serviceUserDescriptionInputPlaceholder: "Introducir descripción",
    expirationDateLabel: "Fecha de vencimiento",
    noExpirationDateText: "No hay fecha de vencimiento disponible",
    updateServiceUserButtonText: "Actualizar usuario del servicio",
    cancelButtonText: "Cancelar",
    activeStatusText: "Activo",
    inactiveStatusText: "Inactivo",
    initialStatusText: "Inicial",
    rolesWarningText: "Asigna al menos un rol al usuario del servicio.",
    inputsCheckWarningText: "Corrige los siguientes campos",
    userUpdatedSuccessText: "Usuario del servicio actualizado correctamente",
    detailsAndStatusErrorText:
      "No se pudieron actualizar los detalles y el estado del usuario del servicio",
    detailsErrorText:
      "No se pudieron actualizar los detalles del usuario del servicio",
    statusErrorText: "No se pudo actualizar el estado del usuario del servicio",
  },
};

export const editServiceUserDrawerModalNl = {
  [pageNameKey]: {
    activeStatusText: "Actief",
    cancelButtonText: "Annuleren",
    detailsAndStatusErrorText:
      "Fout bij het bewerken van de gegevens en status van de servicegebruiker",
    detailsErrorText:
      "Fout bij het bewerken van de gegevens van de servicegebruiker",
    editServiceUserTitle: "Servicegebruiker bewerken",
    expirationDateLabel: "Vervaldatum",
    inactiveStatusText: "Inactief",
    initialStatusText: "Initieel",
    inputsCheckWarningText: "Corrigeer de volgende velden",
    noExpirationDateText: "Geen vervaldatum beschikbaar",
    rolesWarningText: "Wijs de servicegebruiker minimaal één rol toe.",
    serviceUserDescriptionInputPlaceholder: "Beschrijving invoeren",
    serviceUserDescriptionLabel: "Beschrijving",
    serviceUserNameInputPlaceholder: "Naam invoeren",
    serviceUserNameLabel: "Naam",
    serviceUserUsernameInputPlaceholder: "Servicegebruikersnaam invoeren",
    serviceUserUsernameLabel: "Servicegebruikersnaam",
    statusErrorText:
      "Fout bij het bewerken van de status van de servicegebruiker",
    updateServiceUserButtonText: "Servicegebruiker bewerken",
    userUpdatedSuccessText: "Servicegebruiker succesvol bijgewerkt",
  },
};

export const editServiceUserDrawerModalTr = {
  [pageNameKey]: {
    activeStatusText: "Aktif",
    cancelButtonText: "İptal etmek",
    detailsAndStatusErrorText:
      "Hizmet kullanıcısı ayrıntıları ve durumu güncellenemedi",
    detailsErrorText: "Hizmet kullanıcısı ayrıntıları güncellenemedi",
    editServiceUserTitle: "Hizmet kullanıcısını düzenle",
    expirationDateLabel: "Son kullanma tarihi",
    inactiveStatusText: "Etkin değil",
    initialStatusText: "İlk",
    inputsCheckWarningText: "Lütfen aşağıdaki alanları düzeltin",
    noExpirationDateText: "Son kullanma tarihi mevcut değil",
    rolesWarningText: "Lütfen hizmet kullanıcısına en az bir rol atayın.",
    serviceUserDescriptionInputPlaceholder: "Açıklamayı girin",
    serviceUserDescriptionLabel: "Tanım",
    serviceUserNameInputPlaceholder: "Ad girin",
    serviceUserNameLabel: "İsim",
    serviceUserUsernameInputPlaceholder: "Hizmet kullanıcı adını girin",
    serviceUserUsernameLabel: "Hizmet kullanıcı adı",
    statusErrorText: "Hizmet kullanıcısı durumu güncellenemedi",
    updateServiceUserButtonText: "Hizmet kullanıcısını güncelle",
    userUpdatedSuccessText: "Hizmet kullanıcısı başarıyla güncellendi",
  },
};
